<template>
    <div class="table-responsive w-50">
        <table class="table table-striped table-hover text-nowrap">
            <thead>
                <tr>
                    <th v-for="header in headers" :key="headers.indexOf(header)" scope="col" class="border-top-0"> {{ $gettext(header) }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in filteredRows" :key="filteredRows.indexOf(row)">
                    <td v-for="(n, i) in row.length" :key="i">{{ row[i] }}</td>
                </tr>
                <tr v-if="rows.length > limit">
                    <td>...</td>
                    <td>...</td>
                    <td>...</td>
                    <td>...</td>
                    <td>...</td>
                    <td>...</td>
                    <td>...</td>
                    <td>...</td>
                    <td>...</td>
                    <td>...</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import GekkoButton from "@/components/GekkoButton";
export default {
    name: "ImportDataTable",
    props: {
        type: {
            type: String,
            default: ""
        },
        rows: Array,
        source: String
    },
    components: { GekkoButton },
    data() {
        return {
            typeOf: this.type,
            sourceOf: this.source,
            limit: 5
        }
    },
    computed: {
        headers: function () {
            let headers = []
            if (this.typeOf == 'costs') {
                headers = ["Date", "Total Amount (inc. VAT)", "VAT 21%", "VAT 6%", "VAT Exempt", "VAT Reversed Charge", "Description", "Reference", "Paid With", "Cost Type", "Customer", "Project"]
            }
            else if (this.typeOf == 'customers') {
                if (this.sourceOf == 'gekko') {
                    headers = ["Company Name", "First line contact", "Email", "Phone", "CoC Number", "VAT identification number", "Address", "Postal code", "City", "Country", "Notes", "Hourly Rate", "km Compensation", "Payment Term", "Archived"]
                }
                else if (this.sourceOf == 'moneybird') {
                    headers = ["Company Name", "Email", "Phone", "Address", "Postal code", "City", "Country", "VAT identification number", "CoC Number", "Contact Name"]
                }
            }
            return headers
        },

        selected: function (rows) {
            let result = []
            if (this.typeOf == 'costs') {
                result = rows
            }

            else if (this.typeOf == 'customers') {
                if (this.sourceOf == 'gekko') {
                    result = rows
                }
                else if (this.sourceOf == 'moneybird') {
                    // Only include the following cells: 1,4,5,7,9,10,11,12,13,15
                    let selection = [1, 4, 5, 7, 9, 10, 11, 12, 13, 15]
                    result = selection.map(i => rows[i])
                }
            }
            return result
        },
        filteredRows: function () {
            let filtered = this.rows.slice(0, this.limit)
            return filtered
        }
    }
}
</script>
<style scoped></style>